import { render, staticRenderFns } from "./brew.vue?vue&type=template&id=7963bb04&"
import script from "./brew.vue?vue&type=script&lang=js&"
export * from "./brew.vue?vue&type=script&lang=js&"
import style0 from "./brew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports